import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export interface ILoteDocumento {
  codLoja: number;
  tipo: string;
  codFor: number;
  nomeFor: string;
  documento: string;
  np: number;
  totalParcelas: number;
  emissao: string;
  vencimento: string;
  obs: string | null;
  desconto: number;
  jurosPago: number;
  taxaCartorio: number;
  multa: number;
  valorRestante: number;
  valorDoc: number;
}

export interface ILoteDocumentoAgrupadoPorLoja {
  id: number;
  razaoSocial: string;
  totalLoja: number;
  documentos: ILoteDocumento[];
}

export const ObterDocumentosDoLoteAgrupadosPorLoja = async (
  IdLote: string
): Promise<ILoteDocumentoAgrupadoPorLoja[]> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get(
      `/obter-documentos-do-lote-agrupados-por-loja`,
      {
        params: { IdLote },
        headers: { token },
      }
    );

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não conseguimos buscar informações dos lotes de contas a pagar"
    );
  }
};